import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import Layout from '../Layout/Layout';
import MarkdownContent from '../MarkdownContent/MarkdownContent';
import SectionTitle from '../SectionTitle/SectionTitle';

import styles from './LongFormContent.scss';

const propTypes = {
    intro: PropTypes.string,
    namespace: PropTypes.string.isRequired,
    sections: PropTypes.arrayOf(PropTypes.object),
    shortcuts: PropTypes.arrayOf(PropTypes.object),
    useSEOStyles: PropTypes.bool,
};

const defaultProps = {
    intro: '',
    sections: [],
    shortcuts: [],
    useSEOStyles: false,
};

function LongFormContent(props) {
    const {
        intro,
        namespace,
        sections,
        shortcuts,
        t,
        useSEOStyles,
    } = props;

    return (
        <div className={classNames(
            styles.container,
            { [styles.seoContainer]: useSEOStyles },
        )}
        >
            <Layout
                className={classNames(
                    styles.layout,
                    { [styles.seoMainLayout]: useSEOStyles },
                )}
            >
                <div className={styles.content}>
                    {intro && (
                        <MarkdownContent className={styles.sectionContent}>
                            {t(`${namespace}:${intro}`)}
                        </MarkdownContent>
                    )}

                    {sections.map((section) => (
                        <div
                            id={t(`${namespace}:${section.id}`).replace(/\s+/g, '-')}
                            key={section.id}
                        >
                            <SectionTitle className={styles.sectionTitle}>
                                {t(`${namespace}:${section.title}`)}
                            </SectionTitle>

                            <MarkdownContent className={styles.sectionContent}>
                                {t(`${namespace}:${section.description}`)}
                            </MarkdownContent>
                        </div>
                    ))}
                </div>

                <div className={styles.contentIndex}>
                    <span className={styles.indexTitle}>
                        {t(`${namespace}:longContentshortcutTitle`)}
                    </span>

                    {shortcuts.map((section) => (
                        <a
                            className={styles.index}
                            href={`#${t(`${namespace}:${section.id}`).replace(/\s+/g, '-')}`}
                            key={section.id}
                        >
                            {t(`${namespace}:${section.text}`)}
                        </a>
                    ))}
                </div>
            </Layout>
        </div>
    );
}

LongFormContent.propTypes = propTypes;
LongFormContent.defaultProps = defaultProps;

export { LongFormContent };
export default localize(LongFormContent, ['t']);
